import { delay, finalize, Observable, Subject } from 'rxjs';

export function schedulePreload(
	preload$: Observable<void>,
	load: () => Observable<unknown>,
	nextPreloadSubject: Subject<void>
): void {
	preload$.pipe(delay(100)).subscribe(() =>
		requestIdleCallback(() =>
			load()
				.pipe(finalize(() => nextPreloadSubject.next()))
				.subscribe()
		)
	);
}
